// File: components/common/AuthDialog/AuthDialog.jsx
import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { LoginPage, RegisterPage } from "../../../pages/AutenticationPages";
import ForgotPasswordPage from "../../../pages/AutenticationPages/ForgotPasswordPage";
import VerificationPage from "../../../pages/AutenticationPages/VerificationPage";

const AuthDialog = ({ open, onClose, initialView = "login" }) => {
  const [currentView, setCurrentView] = useState(initialView);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)"); 
  const handleViewChange = (view) => setCurrentView(view);

  const handleClose = () => {
    setCurrentView(initialView);
    onClose();
  };

  // Auto-close when screen goes below 600px
  useEffect(() => {
    if (open && isMobile) {
      handleClose();
    }
  }, [isMobile, open]);

  const getComponent = () => {
    switch (currentView) {
      case "register":
        return (
          <RegisterPage onClose={handleClose} onViewChange={handleViewChange} />
        );
      case "forgot":
        return (
          <ForgotPasswordPage
            onClose={handleClose}
            onViewChange={handleViewChange}
          />
        );
      case "verify":
        return (
          <VerificationPage
            onClose={handleClose}
            onViewChange={handleViewChange}
          />
        );
      case "login":
      default:
        return (
          <LoginPage onClose={handleClose} onViewChange={handleViewChange} />
        );
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "1066px",
          width: isTablet ? "85%" : "100%",
          borderRadius: "22px",
          overflow: "visible",
        },
      }}
    >
      <Box position="absolute" top={8} right={8} zIndex={1}>
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{
            display: { xs: "none", sm: "inline-flex" ,width:"25px"},
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      {getComponent()}
    </Dialog>
  );
};

export default AuthDialog;
